import { render, staticRenderFns } from "./StandardButtonIcons.vue?vue&type=template&id=d2fed578&scoped=true"
import script from "./StandardButtonIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardButtonIcons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fed578",
  null
  
)

export default component.exports